import { FileText, Image as ImageIcon, FileIcon } from 'lucide-react';

export const getFileIcon = (fileName: string) => {
  if (fileName?.toLowerCase().endsWith('.pdf')) {
    return (
      <div className="w-9 h-11 bg-red-100 rounded flex items-center justify-center">
        <FileText className="w-6 h-6 text-red-600" />
      </div>
    );
  } else if (fileName?.toLowerCase().match(/\.(jpg|jpeg|png|gif|bmp|webp)$/)) {
    return (
      <div className="w-9 h-11 bg-green-100 rounded flex items-center justify-center">
        <ImageIcon className="w-6 h-6 text-green-600" />
      </div>
    );
  } else if (fileName?.toLowerCase().match(/\.(txt|csv)$/)) {
    return (
      <div className="w-9 h-11 bg-blue-100 rounded flex items-center justify-center">
        <FileText className="w-6 h-6 text-blue-600" />
      </div>
    );
  } else {
    return (
      <div className="w-9 h-11 bg-gray-100 rounded flex items-center justify-center">
        <FileIcon className="w-6 h-6 text-gray-600" />
      </div>
    );
  }
};
